module.exports = __webpack_public_path__ + "img/twitter.a90cd605.svg";